import { connectRefinementList } from 'instantsearch.js/es/connectors';

// 1. Create a render function
const renderRefinementList = (renderOptions, isFirstRender) => {
    const {
        items,
        refine,
        widgetParams,
    } = renderOptions;

    // n'affiche rien si il n'y a pas de donnée dans le refinement liste
    if(items.length === 0) {
        widgetParams.container.innerHTML = '';
        return;
    }
    // n'affiche rien si il n'y a pas de donnée dans les filtres
    if (typeof widgetParams.filtres === 'undefined' || widgetParams.filtres === '') {
        widgetParams.container.innerHTML = '';
        return;
    }

    // Si c'est le premier rendu on crée la liste
    if (isFirstRender) {
        const ul = document.createElement('ul');
        widgetParams.container.appendChild(ul);
    }

    // Permet d'afficher ou non le container de filtre si il y a des filtres présent
    if ((widgetParams.filtres && Object.keys(widgetParams.filtres).length === 1) || (items.length === 0) || (Object.keys(widgetParams.filtres).length === 0)) {
        widgetParams.container.style.display = "none";
    } else {
        widgetParams.container.style.display = "block";
    }

    widgetParams.container.innerHTML = `
    <div class="filtres-content-interne" id="accordion-filtres">
        
        <div 
            id="header_categories" 
            class="filtres-header" 
            data-toggle="collapse" 
            data-target="#content_${widgetParams.attribute}" 
            aria-expanded="true" 
            aria-controls="content_${widgetParams.attribute}"
        >
            <div class="filtres-header-interne">${widgetParams.attributeLabel}</div>
        </div>
        <div id="content_${widgetParams.attribute}" class="filtres-content collapse show" aria-labelledby="header_${widgetParams.attribute}">
            <div class="filtres-content-interne" id="${widgetParams.attribute}">
                <div>
                    <div class="ais-root ais-refinement-list">
                        <div class="ais-body ais-refinement-list--body">
                            <div class="ais-refinement-list--list"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
   `;
   // On change l'object en tableau
   if (typeof widgetParams.filtres === 'object') {
        widgetParams.filtres = Object.values(widgetParams.filtres);
   }
   // On copie le tableau puis on le trim
   let filtres = [...widgetParams.filtres];
   filtres = filtres.map(filtre => filtre.trim());
   // Permet de récupérer que les filtres qui sont en communs avec les items
    let tabFiltres = items.filter(item => filtres.includes(item.label));
    // Affiche la liste des filtres à partir de tabFiltres
    widgetParams.container.querySelector('.ais-refinement-list--list').innerHTML = tabFiltres
        .map(
        item => `
        ${item.count > 0 ? `
            <div class="ais-refinement-list--item ${item.isRefined ? 'ais-refinement-list--item__active' : ''}" >
                <div>
                    <label class="ais-refinement-list--label">
                        <input 
                            type="checkbox" 
                            class="ais-refinement-list--checkbox" 
                            value="${item.value}"
                            data-value="${item.label}"
                        >
                        ${item.label}
                        <span class="ais-refinement-list--count">(${item.count})</span>
                    </label>
                </div>
            </div>
        ` : '' }
        `
        ).join('');

    [...widgetParams.container.querySelectorAll('input')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            refine(event.currentTarget.dataset.value);
        });
    });


};

const customRefinementList = connectRefinementList(renderRefinementList);

export default customRefinementList;